import { Select } from 'antd';
import { CollapsibleSection } from '@/shared/ui/CollapsibleSection';
import type { AdminStudyFilterOptions } from './useAdminStudyFilterOptions';
import styles from './AdminStudyFilterRail.module.css';

interface AdminPersonnelSectionProps {
  selectedReferringPhysicians: string[];
  onReferringPhysiciansChange: (v: string[]) => void;
  selectedInterpretingPhysicians: string[];
  onInterpretingPhysiciansChange: (v: string[]) => void;
  selectedSonographers: string[];
  onSonographersChange: (v: string[]) => void;
  referringOptions: AdminStudyFilterOptions['referringOptions'];
  physicianOptions: AdminStudyFilterOptions['physicianOptions'];
  sonographerOptions: AdminStudyFilterOptions['sonographerOptions'];
}

export default function AdminPersonnelSection({
  selectedReferringPhysicians,
  onReferringPhysiciansChange,
  selectedInterpretingPhysicians,
  onInterpretingPhysiciansChange,
  selectedSonographers,
  onSonographersChange,
  referringOptions,
  physicianOptions,
  sonographerOptions,
}: AdminPersonnelSectionProps) {
  const count =
    selectedReferringPhysicians.length +
    selectedInterpretingPhysicians.length +
    selectedSonographers.length;

  const clearAll = () => {
    onReferringPhysiciansChange([]);
    onInterpretingPhysiciansChange([]);
    onSonographersChange([]);
  };

  return (
    <CollapsibleSection title="Personnel" count={count} onClear={clearAll}>
      <div className={styles.filterGroup}>
        <label htmlFor="admin-referring" className={styles.filterLabel}>
          Referring Physician
        </label>
        <Select
          id="admin-referring"
          mode="multiple"
          allowClear
          showSearch
          optionFilterProp="label"
          placeholder="All"
          value={selectedReferringPhysicians}
          onChange={onReferringPhysiciansChange}
          options={referringOptions}
          className={styles.fullWidth}
        />
      </div>
      <div className={styles.filterGroup}>
        <label htmlFor="admin-interpreting" className={styles.filterLabel}>
          Interpreting Physician
        </label>
        <Select
          id="admin-interpreting"
          mode="multiple"
          allowClear
          showSearch
          optionFilterProp="label"
          placeholder="All"
          value={selectedInterpretingPhysicians}
          onChange={onInterpretingPhysiciansChange}
          options={physicianOptions}
          className={styles.fullWidth}
        />
      </div>
      <div className={styles.filterGroup}>
        <label htmlFor="admin-sonographer" className={styles.filterLabel}>
          Sonographer / Tech
        </label>
        <Select
          id="admin-sonographer"
          mode="multiple"
          allowClear
          showSearch
          optionFilterProp="label"
          placeholder="All"
          value={selectedSonographers}
          onChange={onSonographersChange}
          options={sonographerOptions}
          className={styles.fullWidth}
        />
      </div>
    </CollapsibleSection>
  );
}
